import * as React from 'react';

import { translate } from '~l10n/client';
import cx from 'classnames';

import { FocusIndicator } from '~shared/components/FocusIndicator/FocusIndicator';

export function StudentScoreCorrectnessLabel({
  children,
  isAutograded,
  hasOverride,
  isControlsDisabled,
  onClick,
}): React.ReactElement {
  if (isAutograded || hasOverride) {
    const buttonClass = cx(
      'group relative m-0 p-0 transition ease-in-out duration-150',
      'font-sans text-sm font-600 leading-6 antialiased',
      'border-0 appearance-none outline-none select-none',
      'rounded-1 bg-transparent',
      isControlsDisabled
        ? 'text-grey-500'
        : 'cursor-pointer text-cyan-700 hocus:text-cyan-600'
    );

    return (
      <span
        className="font-sans text-sm font-500 text-blue-600"
        id="correctness-label"
      >
        {children}
        {hasOverride ? (
          <>
            ・
            <button
              className={buttonClass}
              onClick={onClick}
              disabled={isControlsDisabled}
              aria-label={
                isAutograded ? translate('Undo') : translate('Clear Grade')
              }
            >
              <FocusIndicator />
              <div aria-hidden>
                {isAutograded ? translate('Undo') : translate('Clear')}
              </div>
            </button>
          </>
        ) : null}
      </span>
    );
  } else {
    return null;
  }
}
